import { getAuth } from 'firebase/auth';
import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';

export interface UpdateUserProfileRequest {
  uid: string;
  firstname: string;
  lastname: string;
  email?: string;
  phone?: string;
  position?: string;
  avatar?: string;
}

export interface UpdateUserProfileResponse {
  success: boolean;
  data?: Record<string, unknown>;
  error?: string;
}

async function updateUserProfile(
  request: UpdateUserProfileRequest
): Promise<UpdateUserProfileResponse> {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new UpdateUserProfileFailure('Utilisateur non connecté', 'not-authenticated');
    }

    const token = await currentUser.getIdTokenResult();
    const apiKeys = token.claims.api_key as string[];

    if (!apiKeys || apiKeys.length === 0) {
      throw new UpdateUserProfileFailure(
        'Aucune clé API trouvée pour cet utilisateur',
        'no-api-key'
      );
    }

    const headers = {
      'x-api-key': apiKeys[0],
    };

    const response = await HttpClient.put('/user', request, token.token, headers);

    return {
      success: true,
      data: response,
    };
  } catch (e) {
    console.error('Error updating user profile:', e);

    if (e instanceof UpdateUserProfileFailure) {
      return {
        success: false,
        error: e.message,
      };
    }

    return {
      success: false,
      error: e instanceof Error ? e.message : 'Erreur inconnue',
    };
  }
}

export class UpdateUserProfileFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateUserProfile;
